import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";

var Section = function Section(_ref) {
  var children = _ref.children,
      background = _ref.background,
      fullWidth = _ref.fullWidth,
      withoutSpacings = _ref.withoutSpacings,
      borderTop = _ref.borderTop,
      borderBottom = _ref.borderBottom;
  var getClassName = getClassNameFactory(Section.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(background, {
        borderTop: borderTop,
        borderBottom: borderBottom
      })
    })
  }, fullWidth ? children : /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner",
      modifiers: classNames({
        withoutSpacings: withoutSpacings
      })
    })
  }, children));
};

Section.displayName = "Section";
Section.backgrounds = ["grayDark", "grayLighter", "grayLightest"];
Section.propTypes = {
  /**
   * Markup elements to render in Section
   */
  children: PropTypes.node,

  /**
   * Set Section to be full width, no Section-inner div
   */
  fullWidth: PropTypes.bool,

  /**
   * Modify Section with background colors
   */
  background: PropTypes.oneOf(Section.backgrounds),

  /**
   * Remove margins and padding on top
   */
  withoutSpacings: PropTypes.bool,
  borderTop: PropTypes.bool,
  borderBottom: PropTypes.bool
};
export default Section;